<template>
  <BaseButton primary outline small class="w-full" @click="open">
    <span class="truncate"> Add Category </span>
  </BaseButton>
</template>

<script>
import { accountTagCategoriesClient } from '@/api/clients';

export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showForm: false,
    };
  },
  methods: {
    async open() {
      this.$modal.show({
        component: () => import('Components/TagCategory/TagCategoryCreateModal.vue'),
        props: {
          action: this.storeTagCategory,
        },
        on: {
          'tag-category-created': (tagCategory) => {
            this.$emit('tag-category-created', tagCategory);
          },
        },
        hideEvent: 'hide',
      });
    },
    storeTagCategory(formData) {
      return accountTagCategoriesClient.store(this.accountId, formData);
    },
  },
};
</script>
